import { render, staticRenderFns } from "./modify-element-component.vue?vue&type=template&id=7116d57e"
import script from "./modify-element-component.vue?vue&type=script&lang=js"
export * from "./modify-element-component.vue?vue&type=script&lang=js"
import style0 from "./modify-element-component.vue?vue&type=style&index=0&id=7116d57e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports